import { Flex, Group, createStyles } from '@mantine/core';

import CustomImage from '@/components/CustomImage';
import DMText from '@/components/DMText';
import { IContent } from '@/types/discoverys';
import { VideoBadge } from './DiscoveryBadges';
import { images } from '@/utils/images';
import themeVariables from '@/styles/themeVariables';

const useDiscoveryContentRelatedVerticalCardStyle = createStyles(() => ({
  contentImage: {
    width: '100%',
    height: 120,
    objectFit: 'cover',
    objectPosition: 'left',
    borderRadius: '0.5rem 0.5rem 0 0',
  },

  descriptionContainer: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    transition: '0.25s all ease',
    ':hover': {
      transform: 'translateY(-3px)',
    },
  },

  footerContainer: {
    display: 'initial',
    alignItems: 'center',
  },

  footerUserProfileImage: {
    borderRadius: '100%',
    margin: '4px 0px auto',
  },

  footerUserName: {
    overflow: 'hidden',
  },
}));

const DiscoveryContentRelatedVerticalCard = ({
  content: { title, type, duration, content_count, user },
}: {
  content: IContent;
}) => {
  const { classes } = useDiscoveryContentRelatedVerticalCardStyle();

  return (
    <div className={classes.descriptionContainer}>
      <CustomImage
        width={21}
        height={21}
        className={classes.footerUserProfileImage}
        src={user.image_url || images.defaultProfile}
        alt="profile"
        errSrc={images.defaultProfile}
      />
      <div className={classes.footerContainer}>
        <Group spacing={8}>
          <DMText
            size={14}
            weight={600}
            dColor={themeVariables.darkMode.normal}
            lineClamp={2}
            lh={1.4}
          >
            {title}
          </DMText>
          {type == 'video' && <VideoBadge />}
        </Group>
        <Flex mt={4} gap={6}>
          <DMText
            size={13}
            weight={400}
            dColor={themeVariables.darkMode.alternative}
          >
            조회수 {content_count.view || 0}
          </DMText>
          <DMText
            size={13}
            weight={400}
            dColor={themeVariables.darkMode.alternative}
          >
            •
          </DMText>
          <DMText
            size={13}
            weight={400}
            dColor={themeVariables.darkMode.alternative}
          >
            {~~(duration / 1000 / 60) || 1}분 분량
          </DMText>
        </Flex>
      </div>
    </div>
  );
};

export default DiscoveryContentRelatedVerticalCard;
